// extracted by mini-css-extract-plugin
export default {"pointLine":"AddPage_pointLine__r8VlV","button":"AddPage_button__i+hXm","addPage":"AddPage_addPage__oG+5v"};